import salesAssociateBlack from "@/assets/icons/payPlansDefaults/Sales Associate.svg";
import salesAssociateWhite from "@/assets/icons/payPlansDefaults/Sales Associate White.svg";
import financeManagerBlack from "@/assets/icons/payPlansDefaults/F&I Manager.svg";
import financeManagerWhite from "@/assets/icons/payPlansDefaults/F&I Manager White.svg";
import salesManagerBlack from "@/assets/icons/payPlansDefaults/Sales Manager.svg";
import salesManagerWhite from "@/assets/icons/payPlansDefaults/Sales Manager White.svg";
import financeDirectorBlack from "@/assets/icons/payPlansDefaults/Finance Director.svg";
import financeDirectorWhite from "@/assets/icons/payPlansDefaults/Finance Director White.svg";
import generalSalesManagerBlack from "@/assets/icons/payPlansDefaults/General Sales Manager.svg";
import generalSalesManagerWhite from "@/assets/icons/payPlansDefaults/General Sales Manager White.svg";
import bdcSalesAssociateBlack from "@/assets/icons/payPlansDefaults/BDC Sales Associate.svg";
import bdcSalesAssociateWhite from "@/assets/icons/payPlansDefaults/BDC Sales Associate White.svg";
import bdcServiceAssociateBlack from "@/assets/icons/payPlansDefaults/BDC Service Associate.svg";
import bdcServiceAssociateWhite from "@/assets/icons/payPlansDefaults/BDC Service Associate White.svg";
import bdcManagerBlack from "@/assets/icons/payPlansDefaults/BDC Manager.svg";
import bdcManagerWhite from "@/assets/icons/payPlansDefaults/BDC Manager White.svg";
import serviceTechnicianBlack from "@/assets/icons/payPlansDefaults/Service Technician.svg";
import serviceTechnicianWhite from "@/assets/icons/payPlansDefaults/Service Technician White.svg";
import serviceAdvisorBlack from "@/assets/icons/payPlansDefaults/Service Advisor.svg";
import serviceAdvisorWhite from "@/assets/icons/payPlansDefaults/Service Advisor White.svg";
import serviceManagerBlack from "@/assets/icons/payPlansDefaults/Service Manager.svg";
import serviceManagerWhite from "@/assets/icons/payPlansDefaults/Service Manager White.svg";
import serviceDirectorBlack from "@/assets/icons/payPlansDefaults/Service Director.svg";
import serviceDirectorWhite from "@/assets/icons/payPlansDefaults/Service Director White.svg";
import serviceForemanBlack from "@/assets/icons/payPlansDefaults/Service Foreman.svg";
import serviceForemanWhite from "@/assets/icons/payPlansDefaults/Service Foreman White.svg";
import internalServiceAdvisorsBlack from "@/assets/icons/payPlansDefaults/Internal Service Advisors.svg";
import internalServiceAdvisorsWhite from "@/assets/icons/payPlansDefaults/Internal Service Advisors White.svg";
import bodyShopManagerBlack from "@/assets/icons/payPlansDefaults/Body Shop Manager.svg";
import bodyShopManagerWhite from "@/assets/icons/payPlansDefaults/Body Shop Manager White.svg";
import bodyShopProdManagerBlack from "@/assets/icons/payPlansDefaults/Body Shop Prod. Manager.svg";
import bodyShopProdManagerWhite from "@/assets/icons/payPlansDefaults/Body Shop Prod. Manager White.svg";
import bodyShopForemanBlack from "@/assets/icons/payPlansDefaults/Body Shop Foreman.svg";
import bodyShopForemanWhite from "@/assets/icons/payPlansDefaults/Body Shop Foreman White.svg";
import bodyShopTechnicianBlack from "@/assets/icons/payPlansDefaults/Body Shop Technician.svg";
import bodyShopTechnicianWhite from "@/assets/icons/payPlansDefaults/Body Shop Technician White.svg";
import bodyShopPainterBlack from "@/assets/icons/payPlansDefaults/Body Shop Painter.svg";
import bodyShopPainterWhite from "@/assets/icons/payPlansDefaults/Body Shop Painter White.svg";
import bodyShopEstimatorBlack from "@/assets/icons/payPlansDefaults/Body Shop Estimator.svg";
import bodyShopEstimatorWhite from "@/assets/icons/payPlansDefaults/Body Shop Estimator White.svg";
import partsCounterAssociateBlack from "@/assets/icons/payPlansDefaults/Parts Counter Associate.svg";
import partsCounterAssociateWhite from "@/assets/icons/payPlansDefaults/Parts Counter Associate White.svg";
import partsManagerBlack from "@/assets/icons/payPlansDefaults/Parts Manager.svg";
import partsManagerWhite from "@/assets/icons/payPlansDefaults/Parts Manager White.svg";
import partsDirectorBlack from "@/assets/icons/payPlansDefaults/Parts Director.svg";
import partsDirectorWhite from "@/assets/icons/payPlansDefaults/Parts Director White.svg";

export const ICONS_GREY = new Map([
	["Sales Associate", salesAssociateBlack],
	["F&I Manager", financeManagerBlack],
	["Sales Manager", salesManagerBlack],
	["Finance Director", financeDirectorBlack],
	["General Sales Manager", generalSalesManagerBlack],
	["BDC Sales Associate", bdcSalesAssociateBlack],
	["BDC Service Associate", bdcServiceAssociateBlack],
	["BDC Manager", bdcManagerBlack],
	["Service Technician", serviceTechnicianBlack],
	["Service Advisor", serviceAdvisorBlack],
	["Service Manager", serviceManagerBlack],
	["Service Director", serviceDirectorBlack],
	["Service Foreman", serviceForemanBlack],
	["Internal Service Advisors", internalServiceAdvisorsBlack],
	["Body Shop Manager", bodyShopManagerBlack],
	["Body Shop Product Manager", bodyShopProdManagerBlack],
	["Body Shop Technician", bodyShopTechnicianBlack],
	["Body Shop Painter", bodyShopPainterBlack],
	["Body Shop Estimator", bodyShopEstimatorBlack],
	["Body Shop Foreman", bodyShopForemanBlack],
	["Parts Counter Associate", partsCounterAssociateBlack],
	["Parts Manager", partsManagerBlack],
	["Parts Director", partsDirectorBlack],
]);

export const ICONS_WHITE = new Map([
	["Sales Associate", salesAssociateWhite],
	["F&I Manager", financeManagerWhite],
	["Sales Manager", salesManagerWhite],
	["Finance Director", financeDirectorWhite],
	["General Sales Manager", generalSalesManagerWhite],
	["BDC Sales Associate", bdcSalesAssociateWhite],
	["BDC Service Associate", bdcServiceAssociateWhite],
	["BDC Manager", bdcManagerWhite],
	["Service Technician", serviceTechnicianWhite],
	["Service Advisor", serviceAdvisorWhite],
	["Service Manager", serviceManagerWhite],
	["Service Director", serviceDirectorWhite],
	["Service Foreman", serviceForemanWhite],
	["Internal Service Advisors", internalServiceAdvisorsWhite],
	["Body Shop Manager", bodyShopManagerWhite],
	["Body Shop Product Manager", bodyShopProdManagerWhite],
	["Body Shop Technician", bodyShopTechnicianWhite],
	["Body Shop Painter", bodyShopPainterWhite],
	["Body Shop Estimator", bodyShopEstimatorWhite],
	["Body Shop Foreman", bodyShopForemanWhite],
	["Parts Counter Associate", partsCounterAssociateWhite],
	["Parts Manager", partsManagerWhite],
	["Parts Director", partsDirectorWhite],
]);
